module.exports = __webpack_public_path__ + "static/assets/22cc32e4125e46f90ee1510aa771107b.svg";